<script setup>
import { ref, watch } from "vue";
const prevMax = ref(true);
const nextMax = ref(false);
const props = defineProps({
    length: {
        type: Number,
        required: true,
    },
});
const idx = defineModel();

function changePrev() {
    if (idx.value === 0) {
        idx.value = props.length - 1;
    } else {
        idx.value = idx.value - 1;
    }
}

function changeNext() {
    if (idx.value === props.length - 1) {
        idx.value = 0;
    } else {
        idx.value = idx.value + 1;
    }
}

watch(
    () => idx.value,
    (newVal) => {
        prevMax.value = newVal === 0;
        nextMax.value = newVal === props.length - 1;
    }
);
</script>

<template>
    <div class="c-slide-btn" :class="{ '-disable': props.length <= 1, '-st': idx === 0, '-ed': idx === props.length - 1 }">
        <button class="c-slide-btn__ico -prev c-hover_br" @click="changePrev"></button>
        <button class="c-slide-btn__ico -next c-hover_br" @click="changeNext"></button>
    </div>
</template>
